(Element as any).prototype.querySelectorParent = function(selectors: string): Element | null
{
	let target: Element | null = this;

	while (target && (target instanceof Element) && !target.matches(selectors))
	{
		target = target.parentElement;
	}

	if (target && (target instanceof Element) && target.matches(selectors))
	{
		return target;
	}
	else
	{
		return null;
	}
}

export {};
